import useProfile from 'hooks/useProfile';
import { useLayoutEffect, useRef } from 'react';
import { preloadSounds } from 'utils/soundsPreload';

const OpenPackAudio = () => {
  const soundMap = preloadSounds();
  const audioRef = useRef(null);
  const {flags} = useProfile();
  const isSoundOn = flags.sound;

  useLayoutEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.09;
    }
  }, [isSoundOn]);

  return (
    <audio ref={audioRef} src={soundMap['openPack'].src} autoPlay muted={!isSoundOn} loop type="audio/mpeg" />
  );
};

export default OpenPackAudio;
